import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IOrganisationImage } from 'src/app/interfaces/organisation-image';
import { OrganisationImageDataSource } from './organisation-image-data-source';

import { ApiService } from '../../../../app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class OrganisationImageApiService {
  constructor(
    private Api: ApiService,
    private commonFunctionService: CommonFunctionService
  ) {}

  public getDataSource(role: string, organisationId: number) {
    return new OrganisationImageDataSource(role, organisationId, this);
  }

  public list(role: string, organisationId: number) {
    return new Promise((resolve, reject) => {
      let endpoint = `${role}/organisations/${organisationId}/OrganisationImages`;
      const url = this.commonFunctionService.findApiUrl(role);
      setTimeout(() =>
        this.Api.get(endpoint, url).then(
          (result: IOrganisationImage[]) => resolve(result),
          (error) => reject(error)
        )
      );
    });
  }

  public save(
    role: string,
    organisationId: number,
    OrganisationImage: IOrganisationImage
  ) {
    let endpoint = `${role}/organisations/${organisationId}/OrganisationImages`;
    let apiUrl = environment.organisationAdminUrl;

    if (role === 'listing-admin') {
      endpoint = `${role}/organisations/${organisationId}/images`;
      apiUrl = environment.listingAdminUrl;
    }

    return this.Api.post(endpoint, OrganisationImage, apiUrl).then(
      (response) => this.Api.handleSuccess(response),
      (error) => this.Api.handleError(error)
    );
  }

  protected endpoint(role: string, organisationId: number, imageId?: number) {
    let endpoint = `${environment.apiUrl}/${role}/organisations/${organisationId}/images`;

    return endpoint;
  }
}
